import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL } from "../config";

const SendPushNotificationPopup = ({
  isOpen,
  onClose,
  onSubmit,
  subscriberId,
}) => {
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const fetchTemplate = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}subscriber/send-email-notification`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data.pushdata;

      setTitle(data.title || "");
      setMessage(data.message || "");
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      subscriberId: subscriberId,
      title: title,
      message: message,
    };

    setLoading(true);
    const success = await onSubmit(payload);
    setLoading(false);

    if (success) {
      onClose();
      fetchTemplate();
    }
  };


  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-6">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Send Push Notification
              </h5>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-default float-end"
                onClick={onClose}
              >
                &times;
              </button>
            </div>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">Title</label>
                    <input
                      type="text"
                      placeholder="Enter Title"
                      className="form-control"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <fieldset className="form-group">
                    <label className="form-label semibold">Message</label>
                    <textarea
                      placeholder="Enter Message"
                      className="form-control"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </fieldset>
                </div>

                <div className="clearfix"></div>

                <div className="col-md-3">
                  <div style={{ float: "left", marginTop: "20px" }}>
                    <button
                      type="submit"
                      name="submit"
                      className="btn btn-primary mx-2"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Submit"}
                    </button>

                  </div>
                  <div
                    style={{
                      float: "left",
                      marginTop: "20px",
                      marginLeft: "10px",
                    }}
                  >
                    <button
                      type="button"
                      name="cancel"
                      className="btn btn-default"
                      onClick={onClose} // Close the modal on cancel
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendPushNotificationPopup;
